<template>
  <div class="card-cover" :class="cardPosition">
    <resize-observer @notify="resizeCards" />
    <component ref="cardCoverContent" v-if="isCoverReady" :is="`article-cover-card-${nid}`" :nid="nid" :showAnimation="showAnimation" :parentInitFunctions="parentInitFunctions"></component>
    <template v-if="articleType === 'live'">
      <SpeechBalloonLabel :node="node" size="large-responsive" mainComponent="article-cover-card" showShadow></SpeechBalloonLabel>
    </template>
    <div class="button-wrapper play-button-wrapper">
      <div v-show="isVideoCard && showVideoPlayButton" class="play-button"  @click="playVideo">
        <svg-video-play-icon></svg-video-play-icon>
      </div>
    </div>
    <div class="isCountdownCard" alt="isCountDownCard">
      <widget-count-down v-if="!isEmpty(countDown)" :countDown="countDown"></widget-count-down>
    </div>
    <div class="card-action" ref="card-action" v-on:click="toArticle" v-if="actionText && showAction" :class="{cardInvisible: actionToggle, up: actionUp}">
      <div class="card-action-icon-wrapper">
        <svg-arrow-down></svg-arrow-down>
      </div>
      <div class="card-action-text">{{actionText}}</div>
    </div>
    <slot name="arrowsHover"></slot>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import includes from 'lodash/includes'
  import has from 'lodash/has'
  import get from 'lodash/get'
  import isEmpty from 'lodash/isEmpty'
  import SvgArrowDown from 'static/svg/icon_arrow_down.svg'
  import { getArticleType, isDesktop } from 'mixins/utilities'
  import SvgVideoPlayIcon from 'static/svg/raw/icon_videoplay.svg'
  import { ResizeObserver } from 'vue-resize'

  import WidgetCountDown from 'components/widgets/CountDown.vue'
  import SpeechBalloonLabel from 'components/common/SpeechBalloonLabel'

  import animationHandler from 'components/mixins/animationHandler'

  export default {
    name: 'card-cover',
    mixins: [animationHandler],
    components: {
      SvgArrowDown,
      SvgVideoPlayIcon,
      ResizeObserver,
      WidgetCountDown,
      SpeechBalloonLabel,
    },
    props: {
      nid: [String, Number],
      isHideAnimationElement: [Boolean],
      showVideoPlayButton: [Boolean],
      cardPosition: [String],
      actionToggle: {
        type: Boolean,
        default: false,
      },
      showAction: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        isShowAnimation: false,
        isLoaded: false,
        parentInitFunctions: ['resizeCards'],
        actionUp: false,
      }
    },
    mounted() {
      this.isShowAnimation = !this.isHideAnimationElement
      this.$emit('cardMounted', get(this, 'nid', false))
    },
    computed: {
      ...mapGetters({
        registeredArticleCovers: 'registeredArticleCovers',
        articleCover: 'articleCover',
      }),
      ...mapState(['activeNID']),
      node() {
        return this.$store.getters.node(this.nid) || {}
      },
      cardID() {
        return `card-id-${this.nid}`
      },
      isCoverReady() {
        return includes(this.registeredArticleCovers, this.nid.toString())
      },
      isCountDownCard: {
        cache: false,
        get() {
          return get(this, 'node.isCountDown', false)
        },
      },
      isVideoCard: {
        cache: false,
        get() {
          return get(this, 'node.isCardVideo', false)
        },
      },
      actionText() {
        return this.isVideoCard && this.articleType === 'video' ? 'Watch' : 'Read'
      },
      showAnimation() {
        if (this.isHideAnimationElement) {
          return false
        }
        return this.isShowAnimation
      },
      countDown() {
        if (get(this, 'node.display_countdown', false)) {
          const { launch_date: launchDate = '', title = '' } = get(this, 'product', {})
          return {
            countDate: launchDate,
            header: title,
          }
        }
        return {}
      },
      product() {
        if (get(this, 'node.product')) {
          return this.$store.getters.node(this.node.product)
        }
        return {}
      },
      articleType() {
        return getArticleType(this.node)
      },
    },
    methods: {
      isEmpty,
      showCardAnimation () {
        if (!this.isHideAnimationElement) {
          if (this.isShowAnimation) {
            this.isShowAnimation = false
            setTimeout(() => {
              this.isShowAnimation = true
            }, 300)
          } else {
            this.isShowAnimation = true
          }
        }
      },
      hideAnimationElement () {
        this.isShowAnimation = false
      },
      toArticle() {
        if (this.articleType === 'video') {
          this.playVideo()
        } else if (has(this, '$parent.$parent.topCovertoBody')) {
          this.$parent.$parent.topCovertoBody()
        }
      },
      playVideo() {
        get(this, '$parent.$parent.playVideo', () => {})(!isDesktop())
      },
      hideVideo() {
        get(this, '$parent.$parent.hideVideo', () => {})()
      },
      resizeCards() {
        const width = document.documentElement.clientWidth
        const cardContainer = get(this, '$refs.cardCoverContent.$refs.cardContainer')
        const mobileHeight = get(this, '$refs.cardCoverContent.$refs.mobileHeightWrap')

        if (cardContainer && mobileHeight) {
          if (width >= 1024 || window.matchMedia('(orientation: landscape)').matches) {
            const scale = width / 1440
            cardContainer.style.transform = `scale(${scale})`
          } else {
            const scale = width / 375
            cardContainer.style.transform = 'none'
            mobileHeight.style.transform = `scale(${scale})`
            const mhHeightScale = (mobileHeight.clientHeight * scale) / 2
            mobileHeight.style.marginTop = `-${mhHeightScale}px`
          }
        }
      },
      cardActionAnimate() {
        this.actionUp = true
        setTimeout(() => {
          this.actionUp = false
          this.$parent.$parent.cardActionAnimate = false
        }, 300)
      },
    },
    watch: {
      activeNID(nid) {
        if (get(this, 'cardPosition') === 'top' && nid === get(this, 'node.nid')) {
          this.$emit('cardMounted', nid || false)
          this.isShowAnimation = !this.isHideAnimationElement
        }
      },
    },
  }
</script>


<style lang="scss">
  .card-cover{
    background: $black;
    .progressive-image {
      background-image: none;
    }

    .blur-image {
      width: 100%;
      height: 100%;
      transition: opacity 1s;
      transition-delay: 6s;
      opacity: 1;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0%;
      top: 0%;
      filter: url('#blur-effect--20');
      overflow: hidden;
    }

    .loaded-image {
      opacity: 0;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      transition: opacity 2s ease-in-out;
    }

    .lazyload:not(.loaded) {
      filter: url('#blur-effect--20');
    }

    [data-card] {

      > * {
        border: none !important;
      }
    }

    [data-type="text"] {
      height: auto !important;
    }

    .loaded.lazyload {
      background-image: none !important;

      .blur-image {
       opacity: 0;
     }
    }

    @include respond-to('mobile') {
      .article-cover-card-wrapper{
        height: 100vh;
        height: var(--window-height, 100vh);
        .card-container{
          height: 100vh;
          height: var(--window-height, 100vh);
        }
      }
      .mobile-height-wrap {
        position: absolute;
        top: 50%;
        height: 559px;
        /*height: 100vh;*/
        width: 375px;
        transform-origin: top left;
        z-index: 3;
        will-change: transform;
      }
    }
    @include respond-to('desktop_or_landscape') {
      .article-cover-card-wrapper{
        height: 56.25vw;
        height: calc(var(--window-height, 100vh) * 56.25 / 100);
        min-height: 56.25vw;
        .card-container {
          height: 810px;
          width: 1440px;
          top: 0;
          left: 0;
          transform-origin: top left;
        }
      }
      .mobile-height-wrap {
        position: static;
        height: auto;
        top: auto;
        left: auto;
        transform: none !important;
        transform-origin: none !important;
        margin-top: 0 !important;
      }
    }
  }
</style>
<style lang="scss" scoped>
  .card-cover{
    @include respond-to('mobile') {
      height: 100vh;
      height: var(--window-height, 100vh);
    }

    .play-button {
      svg {
        width: rem-calc(70);
        height: rem-calc(70);
      }
    }

    @include respond-to('desktop_or_landscape') {
      height: calc(100vw * 0.5625);
      .button-wrapper {
        height: calc(100vw * 0.5625);
      }
      .play-button {
        cursor: pointer;
        svg {
          width: 9.722vw;
          height: 9.722vw;
          max-height: rem-calc(140);
          max-width: rem-calc(140);
        }
      }
    }
    position: relative;
    width: 100vw;
    border: 0;
    border-radius: 0;
    overflow: hidden;
    position: relative;
    transform: translateZ(0);

    .button-wrapper {
      z-index: 9999;
      &.play-button-wrapper{
        display: inline;
        height: auto;
        width: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      @include respond-to('desktop'){
        height: 56.25vw;
      }
      @include respond-to('mobile'){
        height: 100vh;
      }
      width: 100vw;
      position: absolute;
      top: 0;
    }

    .card-action {
      @include respond-to('desktop') {
        display: none;
      }
      position: absolute;
      z-index: 13;
      left: 50%;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 rem-calc(55) rem-calc(55) rem-calc(55);
      border-color: transparent transparent rgba(0,0,0, 0.7) transparent;
      transform: translate(-50%, 0);
      &:not(.cardInvisible) {
        bottom: 0;
      }
      &.cardInvisible {
        bottom: rem-calc(-55);
        &.up {
          animation: cardActionAnimate 200ms;
          bottom: 0;
        }
      }


      .card-action-icon-wrapper {
        animation: arrowupdown 1s;
        animation-iteration-count:infinite;
      }
      svg {
        fill: #fff;
        position: absolute;
        transform: translate(-50%, 0);
        left: 50%;
        top: rem-calc(12px);
        width: rem-calc(21);
        height: rem-calc(19);
      }
      .card-action-text {
        color: #fff;
        text-transform: uppercase;
        font: bold rem-calc(12) $barlow;
        position: absolute;
        transform: translate(-50%, 0);
        left: 50%;
        top: rem-calc(36);
      }
    }
    @keyframes arrowupdown {
      0% {
        transform: translate(-50%, -2px);
      }
      50% {
        transform: translate(-50%, 2px);
      }
      100% {
        transform: translate(-50%, -2px);
      }
    }

    @keyframes cardActionAnimate {
      0% {
        bottom: rem-calc(-55);
      }

      100% {
        bottom: rem-calc(0);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CardCover.vue?74903428